import StaticPageLayout from "../components/layout/StaticPageLayout";

const h2 = "text-[1.1rem] font-semibold text-[var(--pc-ink)] tracking-[-0.02em] mt-10 mb-3 first:mt-0";

export default function MentionsLegalesPage() {
  return (
    <StaticPageLayout
      pageTitle="Mentions légales — Prévention Conseil"
      h1="Mentions légales"
    >
      <h2 className={h2}>Éditeur du site</h2>
      <p className="mb-0">
        Prévention Conseil — Exploité par la société ECORENO FRANCE
        <br />
        SASU au capital de 30 000 €
        <br />
        SIREN : 912 714 094 — SIRET : 912 714 094 00030
        <br />
        RCS Marseille — Immatriculée le 21/04/2022
        <br />
        N° TVA intracommunautaire : FR07912714094
        <br />
        Siège social : 122 rue du Commandant Rolland, 13008 Marseille
        <br />
        Directeur de la publication : Ilan Taieb
      </p>

      <h2 className={h2}>Hébergement</h2>
      <p>
        Vercel Inc. — 340 Pine Street, Suite 900, San Francisco, CA 94104, USA —{" "}
        <a
          href="https://vercel.com"
          target="_blank"
          rel="noreferrer noopener"
          className="font-medium text-[var(--pc-blue)] hover:underline"
        >
          https://vercel.com
        </a>
      </p>

      <h2 className={h2}>Contact</h2>
      <p>
        Téléphone :{" "}
        <a href="tel:+33972124684" className="font-mono-num font-medium text-[var(--pc-blue)] hover:underline">
          09 72 12 46 84
        </a>
        <br />
        Email :{" "}
        <a
          href="mailto:contact@preventionconseil.fr"
          className="font-medium text-[var(--pc-blue)] hover:underline"
        >
          contact@preventionconseil.fr
        </a>
      </p>
    </StaticPageLayout>
  );
}
